import React from 'react';
import { useDispatch } from 'react-redux';

import useSession from '../../hooks/useSession';
import DropDownSelector from 'views/widgets/DropDownSelector.jsx';
import { addMessage } from '../../messages/messageSlice';

export default function InstancePicker(props) {
	
	const { sessionChanging, sessionChanged } = props;
	let { session, isOrgAdmin, setSession, setPreference, persistPreferences } = useSession();
	const dispatch = useDispatch();

	const instanceSelected = (instance) => {		
		if (instance.id == session.instance.id) return;
		sessionChanging();
		setPreference("LAST_INSTANCE_FOR_ROLE_" + session.currentRole.id, instance.id);
		persistPreferences(true, () => switchToInstance(instance));
	};
	
	const switchToInstance = (instance) => {
		fetch(API_URL + "/api/session/instance?id=" + instance.id, {
			method: 'PUT',
			credentials: 'include'
		}).then(function(response) {
			if (!response.ok) throw Error(response.status);
			return response.json();
		}).then(function(newSession) {
			setSession(newSession, true);
			window.location.reload();
		}).catch(function(err) {
			sessionChanged();
			let errMsg = (err.message === '403') ? ("Unauthorized session!") : ("Failed to switch instances, please contact Support.");
			dispatch(addMessage({ type: 'error', msg: errMsg }));
		});
	};
	
	if (isOrgAdmin()) {
		return null;
	} else {
		return (
			<React.Fragment>
				<span
					aria-hidden={true}
					style={{
						paddingRight: "5px"
					}}
				>
					{session.currentRole.workspace.name + ": "}
				</span>
				{ session.instance && (
					<DropDownSelector
						currentItem={session.instance}
						items={session.currentRole.workspace.instances}
						itemSelected={instanceSelected}
						description={"Instance Selector; Selecting a new workspace instance will refresh your session."}
						{...props}
					/>
				)}
				{ !session.instance && (
					<span>No Workspace Instance</span>
				)}
			</React.Fragment>
		);
	}
}